import { createContext } from 'react'

export const LocalizedContext = createContext(null)
